import React from 'react';
import './Page.css';

function About() {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1>About Us</h1>
        
        <section className="page-section">
          <h2>Our Mission</h2>
          <p>
            ExtraByte is an Indian startup dedicated to transforming education through 
            practical, project-based learning. Our mission is to bridge the skill gap in 
            India's job market by empowering students and professionals with industry-ready 
            skills and recognized certifications. We believe in making quality education 
            accessible and affordable for every Indian learner.
          </p>
        </section>

        <section className="page-section">
          <h2>What We Offer</h2>
          <p>
            Our comprehensive internship programs are designed specifically for the Indian 
            market, providing hands-on experience in various technology domains. Each program 
            includes:
          </p>
          <ul>
            <li>Real-world project assignments aligned with Indian industry needs</li>
            <li>Industry-relevant skill development</li>
            <li>Expert guidance and mentorship from experienced professionals</li>
            <li>Government-recognized certificates upon completion</li>
            <li>Affordable pricing starting at ₹1500 - accessible to all</li>
            <li>Support for regional languages and Indian time zones</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>Our Approach</h2>
          <p>
            We believe in "Skill India" through practical learning. Each course is structured 
            around real-world projects that simulate actual workplace scenarios in Indian 
            companies. This approach ensures that you not only learn the concepts but also 
            gain the confidence to apply them in your career, whether you're in a metro city 
            or a tier-2/tier-3 town.
          </p>
        </section>

        <section className="page-section">
          <h2>Why Choose ExtraByte</h2>
          <ul>
            <li><strong>Made in India, For India:</strong> Courses designed for Indian job market requirements</li>
            <li><strong>Affordable Education:</strong> Quality learning at just ₹1500 per course</li>
            <li><strong>Practical Learning:</strong> Focus on hands-on projects rather than just theory</li>
            <li><strong>Flexible Learning:</strong> Learn at your own pace with lifetime access</li>
            <li><strong>Recognized Certificates:</strong> Earn certificates that showcase your skills to Indian employers</li>
            <li><strong>Startup Innovation:</strong> Agile approach to keep content updated with latest trends</li>
            <li><strong>Community Support:</strong> Join a growing community of Indian learners</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>Our Vision</h2>
          <p>
            To be India's most trusted platform for skill development, contributing to the 
            nation's goal of becoming a global technology hub. We aim to upskill 1 million 
            Indian learners by 2027, making India self-reliant in technology education.
          </p>
        </section>
      </div>
    </div>
  );
}

export default About;
